/**
 * @file ua相关处理方法
 */
export default {

    /**
    * 判断是否为safari浏览器
    *
    * @public
    * @return {boolean} 是否为safari浏览器
    */
    isSafari: () => {
        const ua = window.navigator.userAgent;
        /* eslint-disable max-len */
        // eslint-disable-next-line no-useless-escape
        const ret = ua.match(/(MSIE|(?!Gecko.+)Firefox|(?!AppleWebKit.+Chrome.+)Safari|(?!AppleWebKit.+)Chrome|AppleWebKit(?!.+Chrome|.+Safari)|Gecko(?!.+Firefox))(?: |\/)([\d\.apre]+)/);
        /* eslint-enable max-len */
        let likeSafari = false;
        if (ret && ret[1] && ret[1].toLowerCase() === 'safari') {
            likeSafari = true;
        }
        /* eslint-disable max-len */
        return likeSafari && !/CriOS|UCBrowser|fxiOS|QHBrowser|MQQBrowser|baidubrowser|MicroMessenger|SogouMobileBrowser/i.test(ua);
        /* eslint-enable max-len */
    },

    /**
    * 判断是否为手百浏览器
    *
    * @public
    * @return {boolean} 是否为手百浏览器
    */
    isBox: () => / baiduboxapp/.test(navigator.userAgent),

    /**
     * 判断是否为uc浏览器
     *
     * @public
     * @return {boolean} 是否为uc浏览器
     *
     * */
    isUc: () => {
        const ua = window.navigator.userAgent;
        return /UCBrowser|UCWeb/.test(ua);
    },

    /**
     * 判断是否微信访问
     *
     * @private
     * @return  {boolean}
     */
    isWeChat: () => /MicroMessenger/i.test(navigator.userAgent.toLowerCase()),

    /**
    * 判断是否为手机QQ
    *
    * @private
    * @return  {boolean}
    */
    isMobileQQ: () => /^(?!.*Safari).*QQ/.test(navigator.userAgent),

    /**
    * 判断是否为QQ浏览器
    *
    * @private
    * @return  {boolean}
    */
    isQQBrowser: () => /MQQBrowser/i.test(navigator.userAgent),

    /**
     * 获取chrome浏览器版本
     * ，如果不是chrome浏览器返回0
     *
     * @private
     * @return  {number}
     */
    getChromeVersion: () => {
        const arr = navigator.userAgent.split(' ');
        let chromeVersion = '';
        for (let i = 0; i < arr.length; i++) {
            if (/chrome/i.test(arr[i])) {
                chromeVersion = arr[i];
            }
        }
        if (chromeVersion) {
            return Number(chromeVersion.split('/')[1].split('.')[0]);
        }
        return 0;
    },
    /**
     * 判断是否为微博
     *
     * @private
     * @return  {boolean}
     */
    isWeibo: () => /weibo__([0-9.]+)/.test(navigator.userAgent)
};
